import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subject} from "rxjs";
import {ActivityI, RedirectI, TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnChanges {
  destroy$ = new Subject<void>();

  taskStatus = TaskStatus

  @Input() activityData: ActivityI | null = null;
  @Input() taskData: TaskI | null = null;

  url!: string | SafeResourceUrl;
  config!: string;
  currentTaskStatus!: string;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Iframe Changes =>", changes);

    if (changes["taskData"]
    ) {
      this.taskData = changes["taskData"]["currentValue"]
      this.currentTaskStatus = this.taskData?.status?.key || '';
    }

    if (changes["activityData"]) {

      this.activityData = changes["activityData"]["currentValue"]

      const data = this.activityData?.metadata || {};

      const url = (this.activityData?.iframe || {})?.[this.currentTaskStatus] || (this.activityData?.iframe || {})?.['default']

      console.log("iframe url config => ", url);

      this.url = eval("`" + String(url ?? "") + "`");
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url as string)
      console.log('iframe url => ', this.url);
    }
  }
}
